import { render } from "./ChatbotLogsDialog.vue?vue&type=template&id=17e96bf6&scoped=true"
import script from "./ChatbotLogsDialog.vue?vue&type=script&lang=js"
export * from "./ChatbotLogsDialog.vue?vue&type=script&lang=js"

import "./ChatbotLogsDialog.vue?vue&type=style&index=0&id=17e96bf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e96bf6"]])

export default __exports__